var fixField = $("p:contains('dataExternalPersonalDataOutsideEuEeaTransferBasis-YES-OUTSIDE-EU-EEA')");
var fixFieldOther = $("p:contains('Hvilket land overføres det personopplysninger til?')");

var localizedBasis = {
  "EU-STANDARD-DEAL": "EUs standardavtale",
  "PRIVACY-SHIELD": "Privacy Shield (for overføringer til USA før juli 2020)",
  "COUNTRIES-SUFFICIENT-SECURITY": "Land med tilstrekkelig beskyttelsesnivå"
};
if(fixField.length) {
  $.ajax({
      type: "GET",
      url: "/vrtx/__vrtx/app-services/property-query" +
           "?q=" + encodeURIComponent("uri = " + location.pathname) +
           "&fields=*" +
           "&format=json-compact",
      cache: this.useCache,
      contentType: "application/json;charset=utf-8",
      success: (data) => {
        var text = data.results[0].properties["resource:dataExternalPersonalDataOutsideEuEeaTransferBasis"];
        fixField.text("Hva er overføringsgrunnlaget?: " + localizedBasis[text]);
      },
      error: (xhr, textStatus, errorThrown) => {

      }
    });
} else if(fixFieldOther.length) {
  var other = fixFieldOther.find("+ p");
  if(other.length) {
    var otherText = other.text();
    other.text("Hva er overføringsgrunnlaget?: " + otherText);
  }
}
